export default "__VITE_ASSET__b2fcb6c0__"